import { AxiosResponse } from "axios";
import axios from "../../components/Api/Axios";
import UserDetails from "../../views/UserManagement/models/UserDetails";
import BackendServices from "../../components/Api/BackendService";

export default (email?: string): Promise<AxiosResponse<UserDetails>> =>
  !email
    ? Promise.reject()
    : axios.get<UserDetails>(`${BackendServices.USER_SERVICE.USER}/${email}`);
